import { Typography } from "@mui/material";
import cx from "classnames";
import { useTranslate } from "../../hooks/useTranslate";
import "./StatusBox.css";

const StatusBox = (props) => {
    const {
        title, children,
        isWarning, isSuccess, isInfo,
        isCentered,
    } = props;

    const { t } = useTranslate();

    return (
        <div
            className={cx(
                "status-box",
                { "status-box--warning": isWarning },
                { "status-box--success": isSuccess },
                { "status-box--info": isInfo },
                { "status-box--centered": isCentered },
            )}
        >
            {title && (
                <Typography variant="h4" component="div" className="text-primary">
                    {title}
                </Typography>
            )}
            {children}
        </div>
    );
};

export default StatusBox;
